import * as tslib_1 from "tslib";
/** @jsx withSlots */
import { withSlots, getSlots } from '@uifabric/foundation';
import { Stack } from 'office-ui-fabric-react';
export var CardItemView = function (props) {
    var Slots = getSlots(props, {
        root: Stack.Item
    });
    return withSlots(Slots.root, tslib_1.__assign({}, props));
};
//# sourceMappingURL=CardItem.view.js.map